import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RedactionService {

  BaseUrl: string = environment.baseUrl;
  erBaseUrl: string = 'http://localhost:8006';
  
  constructor(private http: HttpClient) {
    // this.erBaseUrl = environment.erBaseUrl;
   }
  
  setErBaseUrl(baseurl: string){
    this.erBaseUrl ='http://localhost:8006';
  }

  getRedactionFilters(ERurl: string, email: string)
  {
    let params = new HttpParams().set('email', email);
    return this.http.get(this.BaseUrl + "/HuLoopRest/huloop/er-settings/get-selected-fields", { params });
  }

  saveRedactionFilters(ERurl: string,body)
  {
    // this.dashboardDetails = body;
    return this.http.post(this.BaseUrl + "/HuLoopRest/huloop/er-settings/send-filters", body);
  }

  checkSharedGroup(ERurl: string, email: string, anotherParam: string, er: string) {
    const body = {
        email: email,
        group_title: anotherParam,  // renamed to match Python endpoint
        extractionredaction: er      // renamed to match Python endpoint
    };
    return this.http.post(this.BaseUrl + "/HuLoopRest/huloop/er-settings/check-shared", body);
}

}

